// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M3.08545 1H19.4997V8.61957H13.5342L20.9138 15.9992H12.9996V23.9134L5.3879 16.3017L5.38253 8.38213L10.471 8.38558L3.08545 1Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-logo-framer-filled')
export default class LogoFramerFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'logo-framer-filled',
    }
  }
}
